export default "__VITE_ASSET__PCBOaJku__"